import styled from "styled-components";
import { HXSimpleDialog } from "./HXSimpleDialog";
import { FlexColumn } from "./common.styles";
import { Text } from "./HXDesktopPage.styles";
export const ImagePreviewDialogParent = styled((HXSimpleDialog)) `
    & .MuiPaper-root {
        min-width: 680px;
        margin: 0;
        padding: 0;
    }

    & .MuiDialogContent-root {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    & .MuiDialogActions-root {
        display: none;
    }
`;
export const MobileImagePreviewDialogParent = styled((HXSimpleDialog)) `
    & .MuiPaper-root {
        width: 100%;
        margin: 0;
        padding: 0;
    }

    & .MuiDialogContent-root {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    & .MuiDialogActions-root {
        display: none;
    }
`;
export const ImagePreview = styled.img `
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    width: auto;
    height: auto;
`;
export const PDFPreviewDialogParent = styled((HXSimpleDialog)) `
    & .MuiPaper-root {
        width: calc(100% - 64px);
        max-height: calc(100% - 64px);
        max-width: 2000px;
        margin: 0;
        padding: 0;
    }

    & .MuiDialogContent-root > * {
        width: 100%;
    }
`;
export const VideoPreviewContainer = styled(FlexColumn) `
    align-items: center;
`;
export const ImageCaption = styled(Text) `
    margin-top: 16px;
    width: 100%;
    text-align: left;
`;
